import { render, staticRenderFns } from "./AssumptionsNonResidentialNewOverall.vue?vue&type=template&id=422b9c58&scoped=true&"
import script from "./AssumptionsNonResidentialNewOverall.vue?vue&type=script&lang=js&"
export * from "./AssumptionsNonResidentialNewOverall.vue?vue&type=script&lang=js&"
import style0 from "./AssumptionsNonResidentialNewOverall.vue?vue&type=style&index=0&id=422b9c58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422b9c58",
  null
  
)

export default component.exports